import { AssetsState, AssetsActionTypes, assetsActionNames } from './types';

const initialState: AssetsState = {
  selectedAsset: undefined,
};

export const assetsReducer = (
  state: AssetsState = initialState,
  action: AssetsActionTypes,
): AssetsState => {
  switch (action.type) {
    case assetsActionNames.SET_ASSET: {
      return {
        ...state,
        selectedAsset: action.payload,
      };
    }
    default:
      return state;
  }
};
